const formula = [
  {
    id: 'simple',
    value: 'simple',
    label: '简单运算',
    tip: '注意：键盘输入数据列做为参数无效，点击右边数据列某一项内容方可生效算数运算符：+, -, *(乘以), /(除以), 如需使用常量负数, 暂时使用单引号或者双引号包裹常量负数',
    example: '无'
  },
  {
    id: 'math',
    value: 'math',
    label: '数学函数',
    children: [ {
      id: 'abs',
      value: 'ABS(param)',
      label: '绝对值:ABS(num) ',
      tip: '获取绝对值',
      example: 'ABS(-1.2) 返回 1.2'
    }, {
      id: 'round',
      value: 'ROUND(param,param) ',
      label: '四舍五入:ROUND(param,param)',
      tip: '该数值是按照指定的小数位数进行四舍五入运算的结果',
      example: 'ROUND(3.1415926, 2) 返回 3.14  ROUND(193, -2) 返回 200'
    }, {
      id: 'int',
      value: 'INT(param)',
      label: '向下取整:INT(number) ',
      tip: '将数字向下舍入到最接近的整数',
      example: 'INT(2.25),返回2'
    }, {
      id: 'mod',
      value: 'MOD(param,param)',
      label: '相除余数:MOD(number,divisor)',
      tip: '返回两数相除的余数,结果的符号与除数相同',
      example: 'MOD(3, 2) 等于 1,MOD(-3, 2) 等于1,MOD(3, -2) 等于-1'
    }, {
      id: 'quotient',
      value: 'QUOTIENT(param, param)',
      label: '相除整数:QUOTIENT(numerator, denominator)',
      tip: '返回除法的整数部分。要放弃除法的余数时，可使用此函数',
      example: 'QUOTIENT(5,2)返回 2'
    }, {
      id: 'rounddown',
      value: 'ROUNDDOWN(param, param)',
      label: '向零舍入:ROUNDDOWN(number, num_digits)',
      tip: '向下(绝对值减小的方向)舍入数字',
      example: 'ROUNDDOWN(3.2, 0)将 3.2 向下舍入，小数位为 0 (3),ROUNDDOWN(3.14159, 3)将 3.14159 向下舍入，保留三位小数 (3.141)'
    }, {
      id: 'roundup',
      value: 'ROUNDUP(param, param)',
      label: '非零向位数:ROUNDUP(number)',
      tip: '向上(绝对值增大的方向)舍入数字',
      example: 'ROUNDUP(3.2)将 3.2 向上舍入， (4),ROUNDUP(3.14159)将 3.14159 向上舍入 (4)'
    }, {
      id: 'trunc',
      value: 'TRUNC(param, param)',
      label: '取整:TRUNC(number, num_digits)',
      tip: '将数字的小数部分截去，返回整数',
      example: 'TRUNC（89.985，2）=89.98,TRUNC（89.985）=89 (即取整),TRUNC（89.985，-1）=80'
    }, {
      id: 'rand',
      value: 'RAND()',
      label: '随机实数:RAND()',
      tip: '返回大于等于 0 且小于 1 的均匀分布随机实数',
      example: '无'
    }, {
      id: 'randbetween',
      value: 'RANDBETWEEN(param, param)',
      label: '随机整数:RANDBETWEEN(bottom, top)',
      tip: '返回位于两个指定数之间的一个随机整数',
      example: 'RANDBETWEEN(9,100)'
    }, {
      id: 'if',
      value: 'IF(param,param,param)',
      label: '条件判断: IF(param,param,param)',
      tip: '第一个参数为条件, 后面两个参数为数值, 条件满足放回第二个参数, 不满足放回第三个参数',
      example: '示例 if (1>2, 3, 4) 返回 4. '
    }]
  },
  {
    id: 'concat',
    value: 'concat',
    label: '聚合函数',
    children: [
      {
        id: 'average',
        value: 'AVERAGE(param)',
        label: '平均值:AVERAGE(num) ',
        tip: '求平均值',
        example: 'AVERAGE(1) 返回 1 (聚合函数只能允许一个参数)'
      }, {
        id: 'sum',
        value: 'SUM(param)',
        label: '求和:SUM(param) ',
        tip: '求和',
        example: 'SUM(3) 返回3 (聚合函数只能允许一个参数)'
      }, {
        id: 'sumif',
        value: 'SUMIF(param, param, param)',
        label: '条件求和:SUMIF(param, param, param) ',
        tip: '条件求和',
        example: 'SUMIF([1,2,3,4], \'>2\', [1,2,3,4]) 返回 7, 注意, SUMIF 函数中的第一个参数和第二个参数只能使用变量, 即选择右侧 * 下面的列, 第二个参数目前仅支持手动输入常量, 不能使用变量'
      },
      {
        id: 'averageif',
        value: 'AVERAGEIF(param, param, param)',
        label: '条件求平均数:AVERAGEIF(param, param, param) ',
        tip: '条件求和'
      }, {
        id: 'count',
        value: 'COUNT(param)',
        label: '个数:COUNT(num) ',
        tip: '求个数',
        example: 'COUNT(1) 返回 1 (聚合函数只能允许一个参数)'
      }, {
        id: 'max',
        value: 'MAX(param) ',
        label: '最大值:MAX(param) ',
        tip: '求最大值',
        example: 'MAX(3) 返回3 (聚合函数只能允许一个参数)'
      }, {
        id: 'simple',
        value: 'min(param) ',
        label: '最小值:MIN(param) ',
        tip: '求最小值',
        example: 'MIN(3) 返回3 (聚合函数只能允许一个参数)'
      }, {
        id: 'large',
        value: 'LARGE(param,param)',
        label: '最大值:LARGE(array,k) ',
        tip: '返回数据集中第 k 个最大值',
        example: 'LARGE([1,2,3,4,5,6,7,8,9],3)第三个最大值为7'
      }, {
        id: 'small',
        value: 'SMALL(param,param)',
        label: '最小值:SMALL(array,k) ',
        tip: '返回数据集中第 k 个最小值',
        example: 'SMALL([1,2,3,4,5,6,7,8,9],3)第三个最小值为3'
      }, {
        id: 'median',
        value: 'MEDIAN(param,param)',
        label: '中值:MEDIAN(number1, number2, ...) ',
        tip: '返回一组已知数字的中值',
        example: 'MEDIAN(3,21,66,100,29) 返回29'
      }]
  },
  {
    id: 'text',
    value: 'text',
    label: '字符串函数',
    children: [{
      id: 'left',
      value: 'LEFT(param,param)',
      label: '取左:LEFT(param,length)',
      tip: '从文本字符串的第一个字符开始返回指定个数的字符',
      example: 'LEFT("abcdefg", 3) 返回 abc'
    }, {
      id: 'right',
      value: 'RIGHT(param,param)',
      label: '取右:RIGHT(param,length)',
      tip: '从内容字符串的最后一个字符开始返回指定长度的字符',
      example: 'RIGHT("abcdefg", 3) 返回 efg'
    }, {
      id: 'replace',
      value: 'REPLACE(param,param,param,param)',
      label: '替换:REPLACE(old_str, start, length, new_str)',
      tip: '将指定的 old_str 中从 start 开始, 到 length 长度个字符串替换成 new_str.如果需要在某一文本字符串中替换指定的文本，请使用函数 SUBSTITUTE',
      example: 'REPLACE("abcdefg", 3, 2, "xyz") 返回 abcxyzfg'
    }, {
      id: 'concat',
      value: 'CONCAT(param,param)',
      label: '拼接处理:CONCAT(param,param,...)',
      tip: '将字符串或公式进行拼接处理, 字符串使用单双引号包裹.报表模块使用时可以不使用引号包裹',
      example: 'CONCAT("a", 1+2, "b") 返回 a3b'
    }]
  },
  {
    id: 'date',
    value: 'date',
    label: '日期函数',
    children: [{
      id: 'now',
      value: 'NOW()',
      label: '当前时间:NOW()',
      tip: '获取当前时间',
      example: 'NOW() 返回 2018-08-27 17:03:23'
    }, {
      id: 'today',
      value: 'TODAY()',
      label: '当前日期:TODAY()',
      tip: '获取当前日期',
      example: 'TODAY() 返回 2018-08-27'
    }, {
      id: 'days',
      value: 'DAYS(param,param)',
      label: '天数差:DAYS(startDate, endDate)',
      tip: '获取两个日期的天数差',
      example: 'DAYS("2018-08-27", "2018-09-22") 返回 25, DAYS("2018-09-22", "2018-08-27") 返回 -25'
    }, {
      id: 'seconds',
      value: 'SECONDS(param,param)',
      label: '秒差:SECONDS(startDate, endDate)',
      tip: '获取两个日期或时间的秒数差',
      example: 'SECONDS("2019-01-15 14:20:54", "2019-01-15 14:20:53") 返回 1, 注意, 如果使用一个日期和时间进行计算, 时间会从 1970-01-01 开始计时, 日期会从当天的 00:00:00 开始计算, 计算结果可能会超出预期之外'
    }, {
      id: 'edate',
      value: 'EDATE(param,param)',
      label: 'EDATE(startDate, num)',
      tip: ' 返回一个日期，与指定日期 startDate 距离指定的月数 num',
      example: 'EDATE("2018-01-31", -1) 返回 "2017-12-31". EDATE("2018-01-31", 1) 返回 "2018-02-28"'
    }, {
      id: 'eomonth',
      value: 'EOMONTH(param)',
      label: '指定月份的最后一天:EOMONTH(startDate)',
      tip: '获取指定月份 startDate 的最后一天',
      example: 'EOMONTH("1970-01-01") 返回 "1970-01-31"'
    }, {
      id: 'isoweeknum',
      value: 'ISOWEEKNUM(param)',
      label: '指定日期在全年的周数:ISOWEEKNUM(param)',
      tip: '获取指定日期 date 在全年的周数.',
      example: 'ISOWEEKNUM("1970-01-01") 返回 1'
    }, {
      id: 'networkdays',
      value: 'NETWORKDAYS(param,param)',
      label: '两个日期的天数差:NETWORKDAYS(startDate,endDate)',
      tip: '获取两个日期 startDate, endDate 之间的工作日天数',
      example: 'NETWORKDAYS("2018-09-03", "2018-09-10") 返回 6, NETWORKDAYS("2018-09-03", "2018-09-10", "2018-09-04", "2018-09-05") 返回 4'
    }, {
      id: 'weekday',
      value: 'WEEKDAY(param)',
      label: '指定日期是一周的第几天:WEEKDAY(date)',
      tip: '指定日期 date 是一周的第几天',
      example: 'WEEKDAY("2018-08-30") 返回 3'
    }, {
      id: 'workday',
      value: 'WORKDAY(param,param)',
      label: '日期之后的若干个工作日 num 的日期:WORKDAY(date, num)',
      tip: '获取指定日期 date 之后的若干个工作日 num 的日期',
      example: ' WORKDAY("2018-08-30", 5) 返回 "2018-09-06" WORKDAY("2018-08-30", 5, "2018-09-03") 返回 "2018-09-07"'
    }
    ]
  }
]

// todo: 报表应该禁用的函数
/* const sqlEnableFormula = ['', '', ''] */
// todo:未实现的函数
// SUBSTITUTE/SMALL/RandEq

export default function getFormula (type) {
  return formula
}



// WEBPACK FOOTER //
// ./src/globalComponent/calculation/formula.js